import { z } from 'zod';
import { endpoint } from './endpoint.js';

export const referenceData = {
  suppliers: endpoint(
    'GET',
    '/suppliers',
    z.object({}),
    z.object({ data: z.array(z.object({ id: z.number(), name: z.string() })) }),
  ),
  formats: endpoint(
    'GET',
    '/media-formats',
    z.object({}),
    z.object({
      data: z.array(z.object({ id: z.number(), label: z.string(), code: z.string() })),
    }),
  ),
};
